const translations = {
  de: {
    tabs: {
      translate: "Übersetzen",
      create: "Erstellen",
    },
    common: {
      logout: "Abmelden",
      targetLang: "Zielsprache",
      clearAll: "Alle Felder leeren",
      anonymizedNotice: "Schützenswerte Daten wurden durch Platzhalter ersetzt und nicht an den {service} gesendet.",
      translationService: "Übersetzungsdienst",
      textService: "Textservice",
      copyToClipboard: "In Zwischenablage kopieren",
      errorFirebaseUnavailable: "Firebase Functions sind nicht verfügbar. Bitte versuche es später erneut.",
      errorNotLoggedIn: "Du musst angemeldet sein, um diese Funktion zu verwenden.",
    },
    settings: {
      title: "Einstellungen",
      close: "Schliessen",
      design: "Design",
      designAria: "App-Design wählen",
      designVariant: "Farbsatz",
      designVariantAriaSw: "Star-Wars-Farbsatz wählen",
      designVariantAriaSt: "Star-Trek-Farbsatz wählen",
      designVariantAriaPr: "Pacific-Rim-Farbsatz wählen",
      designVariantAriaHoneycomb: "Waben-Farbsatz wählen",
      appearanceStandard: "Standard",
      appearanceStarWars: "Star Wars",
      appearanceStarTrek: "Star Trek",
      appearancePacificRim: "Pacific Rim",
      appearanceHoneycomb: "Wabe",
      appearanceHoneycombDark: "Dunkel",
      appearanceHoneycombDusk: "Dämmer",
      appearanceHoneycombLight: "Hell",
      appearancePrGipsy: "Gipsy Danger",
      appearancePrCherno: "Cherno Alpha",
      appearancePrKaiju: "Kaiju Breach",
      appearancePrShatterdome: "Shatterdome",
      appearanceSwRebel: "Rebel Alliance",
      appearanceSwEmpire: "Galactic Empire",
      appearanceSwJedi: "Jedi Order",
      appearanceSwSith: "Sith",
      appearanceSwMandalorian: "Mandalorian",
      appearanceStTng: "The Next Generation",
      appearanceStTos: "The Original Series",
      appearanceStDs9: "Deep Space Nine",
      appearanceStVoyager: "Voyager",
      appearanceStDiscovery: "Discovery",
      chromeStyle: "Ansicht",
      chromeStyleAria: "Hologramm- oder Normalansicht wählen",
      chromeStyleHologram: "Hologramm",
      chromeStyleClassic: "Normal",
      sfxMuteTooltip: "Geräusche ausschalten",
      sfxUnmuteTooltip: "Geräusche einschalten",
      sfxMuteAria: "Geräusche ausschalten",
      sfxUnmuteAria: "Geräusche einschalten",
      prSfx: "Oberflächen-Geräusche",
      prSfxAria: "Geräusche für das Design ein- oder ausschalten",
      prSfxOutput: "Ausgabegerät",
      prSfxOutputDefault: "Systemstandard",
      prSfxOutputHint: "Eigenes Gerät (z. B. Headset) macht die Töne unabhängig von anderen Apps hörbar.",
      prSfxOutputUnsupported: "Geräteauswahl wird in diesem Browser nicht unterstützt.",
      prSfxOutputLoad: "Geräte laden…",
      prSfxOutputPermTitle: "Audio-Geräte anzeigen",
      prSfxOutputPermBody: "Um Ausgabegeräte mit Namen zu listen, fragt der Browser als Nächstes nach Mikrofonzugriff. Es wird nichts aufgenommen — nur die Geräteliste gelesen.",
      prSfxOutputPermContinue: "Weiter",
      prSfxOutputPermCancel: "Abbrechen",
      prSfxVolume: "Lautstärke",
      prSfxVolumeAria: "Lautstärke der Pacific-Rim-Geräusche",
      prSfxVolumeValue: "{percent} %",
      prSfxVolumeHint: "Über 100 % Boost — Mail-Töne lauter im Mix. Für echte Trennung eigenes Ausgabegerät wählen.",
      prSfxActions: "Geräusch pro Aktion",
      prSfxActionClick: "Klick",
      prSfxActionHover: "Hover",
      prSfxActionDragStart: "Ziehen starten",
      prSfxActionDragMove: "Ziehen bewegen",
      prSfxActionDrop: "Ablegen",
      prSfxActionScroll: "Scrollen",
      prSfxActionSelect: "Auswahl",
      prSfxActionToggle: "Schalter",
      prSfxActionExpand: "Bereich aufklappen",
      prSfxActionCollapse: "Bereich zuklappen",
      prSfxActionKey: "Tasteneingabe",
      prSfxActionMarquee: "Mehrfachauswahl",
      prSfxSoundOff: "Aus",
      prSfxSoundBlip: "Blip",
      prSfxSoundPing: "Ping",
      prSfxSoundChirp: "Chirp",
      prSfxSoundThud: "Thud",
      prSfxSoundScrape: "Scrape",
      prSfxSoundTick: "Tick",
      prSfxSoundTickSoft: "Tick weich",
      prSfxSoundSweepUp: "Sweep hoch",
      prSfxSoundSweepDown: "Sweep runter",
      prSfxSoundType: "Tippen",
      prSfxSoundScan: "Scan",
      prSfxSoundBuzz: "Buzz",
      prSfxSoundPop: "Pop",
      prSfxSoundSaber: "Lichtschwert",
      prSfxSoundBlaster: "Blaster",
      prSfxSoundHoloBeep: "Holo-Beep",
      prSfxSoundForceWhoosh: "Macht-Whoosh",
      prSfxSoundLcarsBeep: "LCARS-Beep",
      prSfxSoundTransporter: "Transporter",
      prSfxSoundCommChirp: "Comm-Chirp",
      prSfxSoundRedAlert: "Rot-Alarm",
      prSfxAmbient: "Hintergrund-Summen",
      prSfxAmbientAria: "Leises Dauersummen im Hintergrund ein- oder ausschalten",
    },
    login: {
      welcome: "Willkommen",
      googleLogin: "Mit Google anmelden",
      or: "oder",
      email: "E-Mail",
      password: "Passwort",
      passwordRepeat: "Passwort wiederholen",
      register: "Registrieren",
      emailLogin: "Mit E-Mail anmelden",
      alreadyRegistered: "Schon registriert? Anmelden",
      noAccount: "Noch kein Account? Registrieren",
      errorInvalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
      errorPasswordMismatch: "Die Passwörter stimmen nicht überein.",
      errorPasswordTooShort: "Das Passwort muss mindestens 6 Zeichen lang sein.",
      errorAlreadyRegistered: "Diese E-Mail-Adresse ist bereits in diesem Projekt registriert. Bitte melde dich an.\n\nFalls der Login fehlschlägt, ist die E-Mail möglicherweise im anderen Projekt registriert. In diesem Fall musst du die E-Mail hier registrieren.",
    },
    translation: {
      inputLabel: "E-Mail Text",
      button: "Übersetzen",
      outputLabel: "Übersetzter Text",
      cameraTooltip: "Text aus Foto erkennen",
      ocrProgress: "Texterkennung läuft... {progress}%",
      ocrError: "OCR Fehler: {error}",
      errorEmpty: "Bitte gib einen Text ein.",
      errorNoResponse: "Fehler bei der Übersetzung: Keine Antwort erhalten.",
      errorGeneric: "Fehler bei der Übersetzung: {error}",
    },
    creation: {
      inputLabel: "Grobe Mail-Idee",
      inputLabelPlain: "Text",
      button: "Umformulieren",
      outputLabel: "Höfliche/professionelle Mail",
      outputLabelPlain: "Professioneller Text",
      formalCheckbox: "Höflichkeitsform",
      mailCheckbox: "Mail",
      errorEmpty: "Bitte gib eine grobe Mail-Idee ein.",
      errorNoResponse: "Fehler bei der Umformulierung: Keine Antwort erhalten.",
      errorGeneric: "Fehler bei der Umformulierung: {error}",
    },
    languages: {
      en: "Englisch",
      de: "Deutsch (Schweiz)",
      fr: "Französisch (Schweiz)",
      it: "Italienisch (Schweiz)",
    },
    auth: {
      "auth/email-already-in-use": "Diese E-Mail-Adresse ist bereits registriert. Bitte melde dich an.",
      "auth/invalid-email": "Die E-Mail-Adresse ist ungültig.",
      "auth/operation-not-allowed": "E-Mail/Passwort-Authentifizierung ist nicht aktiviert. Bitte aktiviere sie in der Firebase Console.",
      "auth/weak-password": "Das Passwort ist zu schwach. Bitte verwende ein stärkeres Passwort (mindestens 6 Zeichen).",
      "auth/user-disabled": "Dieser Account wurde deaktiviert.",
      "auth/user-not-found": "Kein Account mit dieser E-Mail-Adresse gefunden.",
      "auth/wrong-password": "Falsches Passwort.",
      "auth/invalid-credential": "Ungültige Anmeldedaten.",
      "auth/network-request-failed": "Netzwerkfehler. Bitte überprüfe deine Internetverbindung.",
      "auth/invalid-continue-uri": "Authentifizierungsfehler: Die Domain ist nicht autorisiert. Bitte überprüfe die Firebase Console Authorized Domains.",
      "auth/popup-blocked": "Popup wurde blockiert. Bitte erlaube Popups für diese Seite.",
      "auth/popup-closed-by-user": "Anmeldung abgebrochen.",
      "auth/cancelled-popup-request": "Popup-Anfrage wurde abgebrochen.",
      fallback: "Ein Fehler ist aufgetreten.",
    },
  },

  en: {
    tabs: {
      translate: "Translate",
      create: "Create",
    },
    common: {
      logout: "Logout",
      targetLang: "Target language",
      clearAll: "Clear all fields",
      anonymizedNotice: "Sensitive data has been replaced with placeholders and was not sent to the {service}.",
      translationService: "translation service",
      textService: "text service",
      copyToClipboard: "Copy to clipboard",
      errorFirebaseUnavailable: "Firebase Functions are not available. Please try again later.",
      errorNotLoggedIn: "You must be logged in to use this feature.",
    },
    settings: {
      title: "Settings",
      close: "Close",
      design: "Design",
      designAria: "Choose app design",
      designVariant: "Color set",
      designVariantAriaSw: "Choose Star Wars color set",
      designVariantAriaSt: "Choose Star Trek color set",
      designVariantAriaPr: "Choose Pacific Rim color set",
      designVariantAriaHoneycomb: "Choose honeycomb color set",
      appearanceStandard: "Standard",
      appearanceStarWars: "Star Wars",
      appearanceStarTrek: "Star Trek",
      appearancePacificRim: "Pacific Rim",
      appearanceHoneycomb: "Honeycomb",
      appearanceHoneycombDark: "Dark",
      appearanceHoneycombDusk: "Dusk",
      appearanceHoneycombLight: "Light",
      appearancePrGipsy: "Gipsy Danger",
      appearancePrCherno: "Cherno Alpha",
      appearancePrKaiju: "Kaiju Breach",
      appearancePrShatterdome: "Shatterdome",
      appearanceSwRebel: "Rebel Alliance",
      appearanceSwEmpire: "Galactic Empire",
      appearanceSwJedi: "Jedi Order",
      appearanceSwSith: "Sith",
      appearanceSwMandalorian: "Mandalorian",
      appearanceStTng: "The Next Generation",
      appearanceStTos: "The Original Series",
      appearanceStDs9: "Deep Space Nine",
      appearanceStVoyager: "Voyager",
      appearanceStDiscovery: "Discovery",
      chromeStyle: "View",
      chromeStyleAria: "Choose hologram or normal view",
      chromeStyleHologram: "Hologram",
      chromeStyleClassic: "Normal",
      sfxMuteTooltip: "Mute sounds",
      sfxUnmuteTooltip: "Unmute sounds",
      sfxMuteAria: "Mute sounds",
      sfxUnmuteAria: "Unmute sounds",
      prSfx: "Interface sounds",
      prSfxAria: "Enable or disable interface sounds for this design",
      prSfxOutput: "Output device",
      prSfxOutputDefault: "System default",
      prSfxOutputHint: "A dedicated device (e.g. headset) keeps tones audible apart from other apps.",
      prSfxOutputUnsupported: "Output device selection is not supported in this browser.",
      prSfxOutputLoad: "Load devices…",
      prSfxOutputPermTitle: "Show audio devices",
      prSfxOutputPermBody: "To list output devices by name, the browser will next ask for microphone access. Nothing is recorded — only the device list is read.",
      prSfxOutputPermContinue: "Continue",
      prSfxOutputPermCancel: "Cancel",
      prSfxVolume: "Volume",
      prSfxVolumeAria: "Pacific Rim sound volume",
      prSfxVolumeValue: "{percent}%",
      prSfxVolumeHint: "Above 100% boosts Mail tones in the mix. For true separation, pick a dedicated output device.",
      prSfxActions: "Sound per action",
      prSfxActionClick: "Click",
      prSfxActionHover: "Hover",
      prSfxActionDragStart: "Drag start",
      prSfxActionDragMove: "Drag move",
      prSfxActionDrop: "Drop",
      prSfxActionScroll: "Scroll",
      prSfxActionSelect: "Select",
      prSfxActionToggle: "Toggle",
      prSfxActionExpand: "Expand section",
      prSfxActionCollapse: "Collapse section",
      prSfxActionKey: "Typing",
      prSfxActionMarquee: "Multi-select",
      prSfxSoundOff: "Off",
      prSfxSoundBlip: "Blip",
      prSfxSoundPing: "Ping",
      prSfxSoundChirp: "Chirp",
      prSfxSoundThud: "Thud",
      prSfxSoundScrape: "Scrape",
      prSfxSoundTick: "Tick",
      prSfxSoundTickSoft: "Soft tick",
      prSfxSoundSweepUp: "Sweep up",
      prSfxSoundSweepDown: "Sweep down",
      prSfxSoundType: "Type",
      prSfxSoundScan: "Scan",
      prSfxSoundBuzz: "Buzz",
      prSfxSoundPop: "Pop",
      prSfxSoundSaber: "Lightsaber",
      prSfxSoundBlaster: "Blaster",
      prSfxSoundHoloBeep: "Holo beep",
      prSfxSoundForceWhoosh: "Force whoosh",
      prSfxSoundLcarsBeep: "LCARS beep",
      prSfxSoundTransporter: "Transporter",
      prSfxSoundCommChirp: "Comm chirp",
      prSfxSoundRedAlert: "Red alert",
      prSfxAmbient: "Background hum",
      prSfxAmbientAria: "Enable or disable a quiet background hum",
    },
    login: {
      welcome: "Welcome",
      googleLogin: "Sign in with Google",
      or: "or",
      email: "Email",
      password: "Password",
      passwordRepeat: "Repeat password",
      register: "Register",
      emailLogin: "Sign in with email",
      alreadyRegistered: "Already registered? Sign in",
      noAccount: "No account? Register",
      errorInvalidEmail: "Please enter a valid email address.",
      errorPasswordMismatch: "The passwords do not match.",
      errorPasswordTooShort: "The password must be at least 6 characters long.",
      errorAlreadyRegistered: "This email address is already registered in this project. Please sign in.\n\nIf the login fails, the email may be registered in another project. In that case, you need to register the email here.",
    },
    translation: {
      inputLabel: "Email text",
      button: "Translate",
      outputLabel: "Translated text",
      cameraTooltip: "Recognize text from photo",
      ocrProgress: "Text recognition in progress... {progress}%",
      ocrError: "OCR Error: {error}",
      errorEmpty: "Please enter a text.",
      errorNoResponse: "Translation error: No response received.",
      errorGeneric: "Translation error: {error}",
    },
    creation: {
      inputLabel: "Rough email idea",
      inputLabelPlain: "Text",
      button: "Rephrase",
      outputLabel: "Polite/professional email",
      outputLabelPlain: "Professional text",
      formalCheckbox: "Formal address",
      mailCheckbox: "Mail",
      errorEmpty: "Please enter a rough email idea.",
      errorNoResponse: "Rephrasing error: No response received.",
      errorGeneric: "Rephrasing error: {error}",
    },
    languages: {
      en: "English",
      de: "German (Switzerland)",
      fr: "French (Switzerland)",
      it: "Italian (Switzerland)",
    },
    auth: {
      "auth/email-already-in-use": "This email address is already registered. Please sign in.",
      "auth/invalid-email": "The email address is invalid.",
      "auth/operation-not-allowed": "Email/password authentication is not enabled. Please enable it in the Firebase Console.",
      "auth/weak-password": "The password is too weak. Please use a stronger password (at least 6 characters).",
      "auth/user-disabled": "This account has been disabled.",
      "auth/user-not-found": "No account found with this email address.",
      "auth/wrong-password": "Wrong password.",
      "auth/invalid-credential": "Invalid credentials.",
      "auth/network-request-failed": "Network error. Please check your internet connection.",
      "auth/invalid-continue-uri": "Authentication error: The domain is not authorized. Please check the Firebase Console Authorized Domains.",
      "auth/popup-blocked": "Popup was blocked. Please allow popups for this site.",
      "auth/popup-closed-by-user": "Sign-in cancelled.",
      "auth/cancelled-popup-request": "Popup request was cancelled.",
      fallback: "An error occurred.",
    },
  },

  fr: {
    tabs: {
      translate: "Traduire",
      create: "Créer",
    },
    common: {
      logout: "Déconnexion",
      targetLang: "Langue cible",
      clearAll: "Effacer tous les champs",
      anonymizedNotice: "Les données sensibles ont été remplacées par des marqueurs et n'ont pas été envoyées au {service}.",
      translationService: "service de traduction",
      textService: "service de texte",
      copyToClipboard: "Copier dans le presse-papiers",
      errorFirebaseUnavailable: "Les Firebase Functions ne sont pas disponibles. Veuillez réessayer plus tard.",
      errorNotLoggedIn: "Vous devez être connecté pour utiliser cette fonctionnalité.",
    },
    settings: {
      title: "Paramètres",
      close: "Fermer",
      design: "Design",
      designAria: "Choisir le design de l’app",
      designVariant: "Palette",
      designVariantAriaSw: "Choisir la palette Star Wars",
      designVariantAriaSt: "Choisir la palette Star Trek",
      designVariantAriaPr: "Choisir la palette Pacific Rim",
      designVariantAriaHoneycomb: "Choisir la palette nid d'abeilles",
      appearanceStandard: "Standard",
      appearanceStarWars: "Star Wars",
      appearanceStarTrek: "Star Trek",
      appearancePacificRim: "Pacific Rim",
      appearanceHoneycomb: "Nid d'abeilles",
      appearanceHoneycombDark: "Sombre",
      appearanceHoneycombDusk: "Crépuscule",
      appearanceHoneycombLight: "Clair",
      appearancePrGipsy: "Gipsy Danger",
      appearancePrCherno: "Cherno Alpha",
      appearancePrKaiju: "Kaiju Breach",
      appearancePrShatterdome: "Shatterdome",
      appearanceSwRebel: "Rebel Alliance",
      appearanceSwEmpire: "Galactic Empire",
      appearanceSwJedi: "Jedi Order",
      appearanceSwSith: "Sith",
      appearanceSwMandalorian: "Mandalorian",
      appearanceStTng: "The Next Generation",
      appearanceStTos: "The Original Series",
      appearanceStDs9: "Deep Space Nine",
      appearanceStVoyager: "Voyager",
      appearanceStDiscovery: "Discovery",
      chromeStyle: "Affichage",
      chromeStyleAria: "Choisir l’affichage hologramme ou normal",
      chromeStyleHologram: "Hologramme",
      chromeStyleClassic: "Normal",
      sfxMuteTooltip: "Couper les sons",
      sfxUnmuteTooltip: "Activer les sons",
      sfxMuteAria: "Couper les sons",
      sfxUnmuteAria: "Activer les sons",
      prSfx: "Sons d'interface",
      prSfxAria: "Activer ou désactiver les sons d'interface",
      prSfxOutput: "Périphérique de sortie",
      prSfxOutputDefault: "Par défaut du système",
      prSfxOutputHint: "Un appareil dédié (p. ex. casque) rend les sons audibles indépendamment des autres apps.",
      prSfxOutputUnsupported: "La sélection du périphérique n’est pas prise en charge dans ce navigateur.",
      prSfxOutputLoad: "Charger les appareils…",
      prSfxOutputPermTitle: "Afficher les appareils audio",
      prSfxOutputPermBody: "Pour lister les sorties avec leur nom, le navigateur demandera l’accès au micro. Rien n’est enregistré — seule la liste des appareils est lue.",
      prSfxOutputPermContinue: "Continuer",
      prSfxOutputPermCancel: "Annuler",
      prSfxVolume: "Volume",
      prSfxVolumeAria: "Volume des sons Pacific Rim",
      prSfxVolumeValue: "{percent} %",
      prSfxVolumeHint: "Au-dessus de 100 % : boost. Pour une vraie séparation, choisissez un périphérique dédié.",
      prSfxActions: "Son par action",
      prSfxActionClick: "Clic",
      prSfxActionHover: "Survol",
      prSfxActionDragStart: "Début du glisser",
      prSfxActionDragMove: "Glisser",
      prSfxActionDrop: "Déposer",
      prSfxActionScroll: "Défilement",
      prSfxActionSelect: "Sélection",
      prSfxActionToggle: "Interrupteur",
      prSfxActionExpand: "Déplier",
      prSfxActionCollapse: "Replier",
      prSfxActionKey: "Saisie",
      prSfxActionMarquee: "Sélection multiple",
      prSfxSoundOff: "Off",
      prSfxSoundBlip: "Blip",
      prSfxSoundPing: "Ping",
      prSfxSoundChirp: "Chirp",
      prSfxSoundThud: "Thud",
      prSfxSoundScrape: "Scrape",
      prSfxSoundTick: "Tick",
      prSfxSoundTickSoft: "Tick doux",
      prSfxSoundSweepUp: "Balayage haut",
      prSfxSoundSweepDown: "Balayage bas",
      prSfxSoundType: "Frappe",
      prSfxSoundScan: "Scan",
      prSfxSoundBuzz: "Buzz",
      prSfxSoundPop: "Pop",
      prSfxSoundSaber: "Sabre laser",
      prSfxSoundBlaster: "Blaster",
      prSfxSoundHoloBeep: "Bip holo",
      prSfxSoundForceWhoosh: "Souffle Force",
      prSfxSoundLcarsBeep: "Bip LCARS",
      prSfxSoundTransporter: "Téléporteur",
      prSfxSoundCommChirp: "Chirp comm",
      prSfxSoundRedAlert: "Alerte rouge",
      prSfxAmbient: "Bourdonnement d'ambiance",
      prSfxAmbientAria: "Activer ou désactiver un léger bourdonnement de fond",
    },
    login: {
      welcome: "Bienvenue",
      googleLogin: "Se connecter avec Google",
      or: "ou",
      email: "E-mail",
      password: "Mot de passe",
      passwordRepeat: "Répéter le mot de passe",
      register: "S'inscrire",
      emailLogin: "Se connecter par e-mail",
      alreadyRegistered: "Déjà inscrit ? Se connecter",
      noAccount: "Pas de compte ? S'inscrire",
      errorInvalidEmail: "Veuillez saisir une adresse e-mail valide.",
      errorPasswordMismatch: "Les mots de passe ne correspondent pas.",
      errorPasswordTooShort: "Le mot de passe doit contenir au moins 6 caractères.",
      errorAlreadyRegistered: "Cette adresse e-mail est déjà enregistrée dans ce projet. Veuillez vous connecter.\n\nSi la connexion échoue, l'e-mail est peut-être enregistré dans un autre projet. Dans ce cas, vous devez enregistrer l'e-mail ici.",
    },
    translation: {
      inputLabel: "Texte de l'e-mail",
      button: "Traduire",
      outputLabel: "Texte traduit",
      cameraTooltip: "Reconnaître le texte à partir d'une photo",
      ocrProgress: "Reconnaissance de texte en cours... {progress}%",
      ocrError: "Erreur OCR : {error}",
      errorEmpty: "Veuillez saisir un texte.",
      errorNoResponse: "Erreur de traduction : aucune réponse reçue.",
      errorGeneric: "Erreur de traduction : {error}",
    },
    creation: {
      inputLabel: "Idée brute de l'e-mail",
      inputLabelPlain: "Texte",
      button: "Reformuler",
      outputLabel: "E-mail poli/professionnel",
      outputLabelPlain: "Texte professionnel",
      formalCheckbox: "Vouvoiement",
      mailCheckbox: "Mail",
      errorEmpty: "Veuillez saisir une idée brute de l'e-mail.",
      errorNoResponse: "Erreur de reformulation : aucune réponse reçue.",
      errorGeneric: "Erreur de reformulation : {error}",
    },
    languages: {
      en: "Anglais",
      de: "Allemand (Suisse)",
      fr: "Français (Suisse)",
      it: "Italien (Suisse)",
    },
    auth: {
      "auth/email-already-in-use": "Cette adresse e-mail est déjà enregistrée. Veuillez vous connecter.",
      "auth/invalid-email": "L'adresse e-mail est invalide.",
      "auth/operation-not-allowed": "L'authentification par e-mail/mot de passe n'est pas activée. Veuillez l'activer dans la Firebase Console.",
      "auth/weak-password": "Le mot de passe est trop faible. Veuillez utiliser un mot de passe plus fort (au moins 6 caractères).",
      "auth/user-disabled": "Ce compte a été désactivé.",
      "auth/user-not-found": "Aucun compte trouvé avec cette adresse e-mail.",
      "auth/wrong-password": "Mot de passe incorrect.",
      "auth/invalid-credential": "Identifiants invalides.",
      "auth/network-request-failed": "Erreur réseau. Veuillez vérifier votre connexion Internet.",
      "auth/invalid-continue-uri": "Erreur d'authentification : le domaine n'est pas autorisé. Veuillez vérifier les domaines autorisés dans la Firebase Console.",
      "auth/popup-blocked": "Le popup a été bloqué. Veuillez autoriser les popups pour ce site.",
      "auth/popup-closed-by-user": "Connexion annulée.",
      "auth/cancelled-popup-request": "Demande de popup annulée.",
      fallback: "Une erreur est survenue.",
    },
  },

  it: {
    tabs: {
      translate: "Tradurre",
      create: "Creare",
    },
    common: {
      logout: "Disconnettersi",
      targetLang: "Lingua di destinazione",
      clearAll: "Cancella tutti i campi",
      anonymizedNotice: "I dati sensibili sono stati sostituiti con segnaposto e non sono stati inviati al {service}.",
      translationService: "servizio di traduzione",
      textService: "servizio di testo",
      copyToClipboard: "Copia negli appunti",
      errorFirebaseUnavailable: "Le Firebase Functions non sono disponibili. Riprova più tardi.",
      errorNotLoggedIn: "Devi essere connesso per utilizzare questa funzione.",
    },
    settings: {
      title: "Impostazioni",
      close: "Chiudi",
      design: "Design",
      designAria: "Scegli il design dell’app",
      designVariant: "Palette colori",
      designVariantAriaSw: "Scegli la palette Star Wars",
      designVariantAriaSt: "Scegli la palette Star Trek",
      designVariantAriaPr: "Scegli la palette Pacific Rim",
      designVariantAriaHoneycomb: "Scegli la palette alveare",
      appearanceStandard: "Standard",
      appearanceStarWars: "Star Wars",
      appearanceStarTrek: "Star Trek",
      appearancePacificRim: "Pacific Rim",
      appearanceHoneycomb: "Alveare",
      appearanceHoneycombDark: "Scuro",
      appearanceHoneycombDusk: "Crepuscolo",
      appearanceHoneycombLight: "Chiaro",
      appearancePrGipsy: "Gipsy Danger",
      appearancePrCherno: "Cherno Alpha",
      appearancePrKaiju: "Kaiju Breach",
      appearancePrShatterdome: "Shatterdome",
      appearanceSwRebel: "Rebel Alliance",
      appearanceSwEmpire: "Galactic Empire",
      appearanceSwJedi: "Jedi Order",
      appearanceSwSith: "Sith",
      appearanceSwMandalorian: "Mandalorian",
      appearanceStTng: "The Next Generation",
      appearanceStTos: "The Original Series",
      appearanceStDs9: "Deep Space Nine",
      appearanceStVoyager: "Voyager",
      appearanceStDiscovery: "Discovery",
      chromeStyle: "Vista",
      chromeStyleAria: "Scegli vista ologramma o normale",
      chromeStyleHologram: "Ologramma",
      chromeStyleClassic: "Normale",
      sfxMuteTooltip: "Disattiva suoni",
      sfxUnmuteTooltip: "Attiva suoni",
      sfxMuteAria: "Disattiva suoni",
      sfxUnmuteAria: "Attiva suoni",
      prSfx: "Suoni interfaccia",
      prSfxAria: "Attiva o disattiva i suoni dell'interfaccia",
      prSfxOutput: "Dispositivo di uscita",
      prSfxOutputDefault: "Predefinito di sistema",
      prSfxOutputHint: "Un dispositivo dedicato (es. cuffie) rende i suoni udibili indipendentemente dalle altre app.",
      prSfxOutputUnsupported: "La selezione del dispositivo non è supportata in questo browser.",
      prSfxOutputLoad: "Carica dispositivi…",
      prSfxOutputPermTitle: "Mostra dispositivi audio",
      prSfxOutputPermBody: "Per elencare le uscite con nome, il browser chiederà l’accesso al microfono. Non viene registrato nulla — solo l’elenco dei dispositivi.",
      prSfxOutputPermContinue: "Continua",
      prSfxOutputPermCancel: "Annulla",
      prSfxVolume: "Volume",
      prSfxVolumeAria: "Volume dei suoni Pacific Rim",
      prSfxVolumeValue: "{percent} %",
      prSfxVolumeHint: "Oltre il 100 %: boost. Per una vera separazione scegli un dispositivo dedicato.",
      prSfxActions: "Suono per azione",
      prSfxActionClick: "Clic",
      prSfxActionHover: "Hover",
      prSfxActionDragStart: "Inizio trascinamento",
      prSfxActionDragMove: "Trascinamento",
      prSfxActionDrop: "Rilascia",
      prSfxActionScroll: "Scorrimento",
      prSfxActionSelect: "Selezione",
      prSfxActionToggle: "Interruttore",
      prSfxActionExpand: "Espandi",
      prSfxActionCollapse: "Comprimi",
      prSfxActionKey: "Digitazione",
      prSfxActionMarquee: "Selezione multipla",
      prSfxSoundOff: "Off",
      prSfxSoundBlip: "Blip",
      prSfxSoundPing: "Ping",
      prSfxSoundChirp: "Chirp",
      prSfxSoundThud: "Thud",
      prSfxSoundScrape: "Scrape",
      prSfxSoundTick: "Tick",
      prSfxSoundTickSoft: "Tick soft",
      prSfxSoundSweepUp: "Sweep su",
      prSfxSoundSweepDown: "Sweep giù",
      prSfxSoundType: "Digitazione",
      prSfxSoundScan: "Scan",
      prSfxSoundBuzz: "Buzz",
      prSfxSoundPop: "Pop",
      prSfxSoundSaber: "Spada laser",
      prSfxSoundBlaster: "Blaster",
      prSfxSoundHoloBeep: "Bip holo",
      prSfxSoundForceWhoosh: "Whoosh Forza",
      prSfxSoundLcarsBeep: "Bip LCARS",
      prSfxSoundTransporter: "Teletrasporto",
      prSfxSoundCommChirp: "Chirp comm",
      prSfxSoundRedAlert: "Allarme rosso",
      prSfxAmbient: "Ronzio di sottofondo",
      prSfxAmbientAria: "Attiva o disattiva un leggero ronzio di sottofondo",
    },
    login: {
      welcome: "Benvenuto",
      googleLogin: "Accedi con Google",
      or: "o",
      email: "E-mail",
      password: "Password",
      passwordRepeat: "Ripeti la password",
      register: "Registrati",
      emailLogin: "Accedi con e-mail",
      alreadyRegistered: "Già registrato? Accedi",
      noAccount: "Nessun account? Registrati",
      errorInvalidEmail: "Inserisci un indirizzo e-mail valido.",
      errorPasswordMismatch: "Le password non corrispondono.",
      errorPasswordTooShort: "La password deve contenere almeno 6 caratteri.",
      errorAlreadyRegistered: "Questo indirizzo e-mail è già registrato in questo progetto. Effettua l'accesso.\n\nSe l'accesso non riesce, l'e-mail potrebbe essere registrata in un altro progetto. In tal caso, devi registrare l'e-mail qui.",
    },
    translation: {
      inputLabel: "Testo dell'e-mail",
      button: "Tradurre",
      outputLabel: "Testo tradotto",
      cameraTooltip: "Riconoscere il testo da una foto",
      ocrProgress: "Riconoscimento testo in corso... {progress}%",
      ocrError: "Errore OCR: {error}",
      errorEmpty: "Inserisci un testo.",
      errorNoResponse: "Errore di traduzione: nessuna risposta ricevuta.",
      errorGeneric: "Errore di traduzione: {error}",
    },
    creation: {
      inputLabel: "Idea grezza dell'e-mail",
      inputLabelPlain: "Testo",
      button: "Riformulare",
      outputLabel: "E-mail cortese/professionale",
      outputLabelPlain: "Testo professionale",
      formalCheckbox: "Forma di cortesia",
      mailCheckbox: "Mail",
      errorEmpty: "Inserisci un'idea grezza dell'e-mail.",
      errorNoResponse: "Errore di riformulazione: nessuna risposta ricevuta.",
      errorGeneric: "Errore di riformulazione: {error}",
    },
    languages: {
      en: "Inglese",
      de: "Tedesco (Svizzera)",
      fr: "Francese (Svizzera)",
      it: "Italiano (Svizzera)",
    },
    auth: {
      "auth/email-already-in-use": "Questo indirizzo e-mail è già registrato. Effettua l'accesso.",
      "auth/invalid-email": "L'indirizzo e-mail non è valido.",
      "auth/operation-not-allowed": "L'autenticazione tramite e-mail/password non è attivata. Attivala nella Firebase Console.",
      "auth/weak-password": "La password è troppo debole. Utilizza una password più forte (almeno 6 caratteri).",
      "auth/user-disabled": "Questo account è stato disattivato.",
      "auth/user-not-found": "Nessun account trovato con questo indirizzo e-mail.",
      "auth/wrong-password": "Password errata.",
      "auth/invalid-credential": "Credenziali non valide.",
      "auth/network-request-failed": "Errore di rete. Verifica la tua connessione Internet.",
      "auth/invalid-continue-uri": "Errore di autenticazione: il dominio non è autorizzato. Verifica i domini autorizzati nella Firebase Console.",
      "auth/popup-blocked": "Il popup è stato bloccato. Consenti i popup per questo sito.",
      "auth/popup-closed-by-user": "Accesso annullato.",
      "auth/cancelled-popup-request": "Richiesta popup annullata.",
      fallback: "Si è verificato un errore.",
    },
  },
};

const SUPPORTED_LANGS = ['de', 'en', 'fr', 'it'];

export function detectLanguage() {
  const browserLang = (navigator.language || navigator.userLanguage || 'en').slice(0, 2).toLowerCase();
  return SUPPORTED_LANGS.includes(browserLang) ? browserLang : 'en';
}

export function getTranslations(lang) {
  return translations[lang] || translations.en;
}
